import request from "@/common/request"

const basePath = '/email'

export const enviarValesPorEmail = (idVenda: string, email: string): Promise<void> =>
	request.post(`${basePath}/${idVenda}/vale-presente/enviar-email?emailDestino=${email}`)